import React from 'react';
import {IconProps} from './types';

const SuccessIcon: React.FC<IconProps> = ({ 
    width = 18, 
    height = 18, 
    className 
}) => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width={width} 
            height={height} 
            viewBox="0 0 18 18" 
            fill="none"
            className={className}
        >
            <path 
                d="M3 9C3 7.4087 3.63214 5.88258 4.75736 4.75736C5.88258 3.63214 7.4087 3 9 3C10.5913 3 12.1174 3.63214 13.2426 4.75736C14.3679 5.88258 15 7.4087 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15C7.4087 15 5.88258 14.3679 4.75736 13.2426C3.63214 12.1174 3 10.5913 3 9ZM9 1.5C4.85775 1.5 1.5 4.85775 1.5 9C1.5 13.1422 4.85775 16.5 9 16.5C13.1422 16.5 16.5 13.1422 16.5 9C16.5 4.85775 13.1422 1.5 9 1.5ZM13.0927 7.09275L12.0322 6.03225L8.25 9.8145L6.15525 7.71975L5.09475 8.78025L8.25 11.9355L13.0927 7.09275Z" 
                fill="#13D361"
            />
        </svg>
    );
};

export default SuccessIcon;
